import './style.css'
import Tooltip from "../../components/ToolTip";
import GlobalSVG from '../../utils/GlobalSVG';

export default function SlideToggle(props) {

    const handleChecked = () => {
        if (props.options) {

            if (props.id === 'gas' && !props.options.gas && props.options.water) {
                props.setOptions(e => ({ ...e, gas: !props.options[props.id], water: false }))
            } else if (props.id === 'water' && !props.options.water && props.options.gas) {
                props.setOptions(e => ({ ...e, water: !props.options[props.id], gas: false }))
            } else {
                props.setOptions(e => ({ ...e, [props.id]: !props.options[props.id], }))
            }
        }
    }


    return (
        <div className="flex flex-nowrap items-between justify-between mt-2 mr-4" >
            {props.name && <div className='flex justify-end items-center mr-2'>
                <label
                    className={`inline-block pl-[0.15rem] hover:cursor-pointer`}
                    htmlFor={props.id}>
                    <p className={`${props.titleClass ? props.titleClass : 'text-[#332D41] font-semibold'}`}>{props.name}</p>
                </label>
                {props.info && <Tooltip
                    text={props.info}
                    right="0"
                    left="400%"
                    top="0"
                    width="200px"
                    height="50px"
                    textAlign="left"
                    show={true}>
                    <div className="ml-2">
                        {GlobalSVG.info('grey', '15', '15')}
                    </div>
                </Tooltip>}
            </div>}
            <div className='flex justify-start ml-2'>
                <label className="switch" htmlFor={props.id}>
                    <input
                        type="checkbox"
                        id={props.id}
                        disabled={props.disabled}
                        checked={props.options && props.options[props.id]}
                        onClick={handleChecked}
                    />
                    <span className={`slider round ${props.id} `}></span>
                </label>
            </div>
        </div>
    );
};